<div class="mb-4 flex">
  @let customCollectionActionsTemplate = customCollectionActionsTemplateRef();
  @let customActionsTemplate = customActionsTemplateRef();

  @if (!isNil(customCollectionActionsTemplate)) {
    <div>
      <ng-container
        [ngTemplateOutlet]="customCollectionActionsTemplate"
        [ngTemplateOutletContext]="{ selection: selection }" />
    </div>
  } @else {
    @if (collectionActions) {
      <div>
        <app-table-collection-actions
          [selection]="selection"
          [actions]="collectionActions" />
      </div>
    }
  }

  @if (!isNil(customActionsTemplate)) {
    <div class="ms-auto">
      <ng-container [ngTemplateOutlet]="customActionsTemplate" />
    </div>
  } @else {
    @if (actions) {
      <div class="ms-auto">
        <app-action-buttons [actions]="actions" />
      </div>
    }
  }
</div>
